import { AnimationIcon } from "@dmm-com/rocket-web-ui-library";
import { memo } from "react";
import { DivContainer } from "./style";
type LoadingProps = {
  isLoading: boolean;
};
export const FetchMoreLoading = memo(({ isLoading }: LoadingProps) => {
  if (!isLoading) return null;

  return (
    <DivContainer>
      <AnimationIcon name="loading" iconSize="XXXL" iconColor="GRAY700" />
    </DivContainer>
  );
});

FetchMoreLoading.displayName = "FetchMoreLoading";
